import './index.scss';
import { defineComponent, h } from 'vue';
import { Vector3 } from 'three';
import { from_normalized_to_actual_screen_coordinates } from '@frontend/utility';
import { from_3d_coordinates_to_2d_screen_coordinates } from '@frontend/geometry_and_math';
import { enable_force_refresh } from '@frontend/state/force-refresh';
import { px } from '@phi/util/css';

export const AxesIndicators = defineComponent({
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
    },

    computed: {
        axis_length() {
            enable_force_refresh();
            return viewSize / 5.0 + viewSize / 40.0;
        },

        cyl_radius() {
            enable_force_refresh();
            return viewSize / 400;
        },

        x() {
            const v = new Vector3(
                this.axis_length,
                0,
                0,
            );
            return from_normalized_to_actual_screen_coordinates(from_3d_coordinates_to_2d_screen_coordinates(v));
        },

        y() {
            const v  = new Vector3(
                0,
                this.axis_length,
                0,
            );
            return from_normalized_to_actual_screen_coordinates(from_3d_coordinates_to_2d_screen_coordinates(v));
        },

        z() {
            const v = new Vector3(
                0,
                0,
                this.axis_length,
            );
            return from_normalized_to_actual_screen_coordinates(from_3d_coordinates_to_2d_screen_coordinates(v));
        },
    },

    render() {
        if (!this.visible) return '';
        else return h('div', { class: 'axes-indicators'}, [
            h('div', {
                class: 'coords-x',
                style: {
                    top: px(this.x.y),
                    left: px(this.x.x),
                }
            }, 'X'),
            h('div', {
                class: 'coords-y',
                style: {
                    top: px(this.y.y),
                    left: px(this.y.x),
                }
            }, 'Y'),
            h('div', {
                class: 'coords-z',
                style: {
                    top: px(this.z.y),
                    left: px(this.z.x),
                }
            }, 'Z'),
        ]);
    }
});
